module.exports = __webpack_public_path__ + "media/images/childcare/card-desktop-bf11a2332f1253ad573fb3656c610ec2.jpg";